import React from 'react';
import { withRouter } from 'react-router-dom'
import RaisedButton from 'material-ui/RaisedButton';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

const ErrorPage = ({ message, errorCode, history}) => {
 return(
   <MuiThemeProvider>
   <div className="ErrorPage">
     <h2>Something went wrong.</h2>
     <p>Error {errorCode}</p>
     <p>{message}</p>
     <RaisedButton label={"Go back to home page."} onClick={() => history.push('/')}/>
   </div>
   </MuiThemeProvider>
 );
};

export default withRouter(ErrorPage);



// WEBPACK FOOTER //
// ./src/Components/ErrorPage/ErrorPage.jsx